<template>
  <div v-if="showItem"
       class="item-standart">
    <div class="avatar">
      <child-avatar :child="child"
                    size="small"
                    :custom-icon-url="item.details.icon_url"
                    :show-status="false" />
    </div>
    <div class="content">
      <div class="description">
        {{ $t("feed.items.installItemAction", { label: item.details.label }) }}
      </div>

      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'

  export default {
    extends: ItemBase,

    props: {
      item: {
        required: true,
        type: Object
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.item.user_id)
      },

      showItem() {
        return this.child
      }
    }
  }
</script>
